import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';

const Navbar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isDarkHero = location.pathname === '/' || location.pathname === '/masterclass' || location.pathname === '/consulting';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => setMobileOpen(false), [location]);

  const links = [
    { to: '/products', label: 'Products' },
    { to: '/consulting', label: 'Consulting' },
    { to: '/masterclass', label: 'Masterclass' },
  ];

  const solid = scrolled || !isDarkHero;

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      solid ? 'bg-white/95 backdrop-blur-lg shadow-[0_1px_0_0_rgba(0,0,0,0.06)]' : 'bg-transparent'
    }`}>
      <div className="max-w-6xl mx-auto px-6 lg:px-8 h-[72px] flex items-center justify-between">
        <Link to="/">
          <img
            src={solid ? '/assets/images/logo_black_text.svg' : '/assets/images/logo2.svg'}
            alt="BuilderThinking"
            className="h-8 lg:h-9 w-auto transition-opacity duration-300"
          />
        </Link>

        <div className="hidden md:flex items-center gap-10">
          {links.map(l => (
            <Link key={l.to} to={l.to}
              className={`text-sm font-medium tracking-wide transition-colors ${
                location.pathname === l.to
                  ? solid ? 'text-gray-900' : 'text-white'
                  : solid ? 'text-gray-500 hover:text-gray-900' : 'text-white/60 hover:text-white'
              }`}
            >{l.label}</Link>
          ))}
        </div>

        <div className="hidden md:block">
          <Link to="/consulting">
            <Button size="sm" className="rounded-full px-6 text-xs font-semibold tracking-wide h-9">
              Work With Us
            </Button>
          </Link>
        </div>

        <button className="md:hidden w-8 h-8 flex flex-col justify-center items-center gap-[5px]"
          onClick={() => setMobileOpen(!mobileOpen)} aria-label="Menu">
          <span className={`block w-[18px] h-[1.5px] ${solid ? 'bg-gray-900' : 'bg-white'} transition-all ${mobileOpen ? 'rotate-45 translate-y-[3.25px]' : ''}`} />
          <span className={`block w-[18px] h-[1.5px] ${solid ? 'bg-gray-900' : 'bg-white'} transition-all ${mobileOpen ? 'opacity-0' : ''}`} />
          <span className={`block w-[18px] h-[1.5px] ${solid ? 'bg-gray-900' : 'bg-white'} transition-all ${mobileOpen ? '-rotate-45 -translate-y-[3.25px]' : ''}`} />
        </button>
      </div>

      <div className={`md:hidden transition-all duration-300 overflow-hidden ${mobileOpen ? 'max-h-72 opacity-100' : 'max-h-0 opacity-0'}`}>
        <div className="bg-white border-t border-gray-100 px-6 py-5 space-y-3">
          {links.map(l => (
            <Link key={l.to} to={l.to}
              className={`block text-[15px] font-medium ${location.pathname === l.to ? 'text-gray-900' : 'text-gray-400'}`}
            >{l.label}</Link>
          ))}
          <Link to="/consulting" className="block pt-2">
            <Button className="w-full rounded-full text-sm font-semibold h-11">Work With Us</Button>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
